export function getDisplayName(args) {
  return {
    type: 'write',
    path: args.path
  };
}
